import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './tire-tread-manufacturer.reducer';

export const TireTreadManufacturerUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const hasSaved = useRef(false);

  const tireTreadManufacturerEntity = useAppSelector(state => state.tireTreadManufacturer.entity);
  const loading = useAppSelector(state => state.tireTreadManufacturer.loading);
  const updating = useAppSelector(state => state.tireTreadManufacturer.updating);
  const updateSuccess = useAppSelector(state => state.tireTreadManufacturer.updateSuccess);

  const [formData, setFormData] = useState<{
    image?: string | null;
    imageContentType?: string | null;
    name?: string | null;
  }>({
    image: null,
    imageContentType: null,
    name: null,
  });

  useEffect(() => {
    if (!isNew && tireTreadManufacturerEntity) {
      setFormData({
        image: tireTreadManufacturerEntity?.image,
        imageContentType: tireTreadManufacturerEntity?.imageContentType,
        name: tireTreadManufacturerEntity?.name,
      });
    }
  }, [tireTreadManufacturerEntity]);

  const handleClose = () => {
    props.history.push('/tire-tread-manufacturer' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess && hasSaved.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...tireTreadManufacturerEntity,
      ...values,
    };

    hasSaved.current = true;

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!formData?.name) {
      return toast.error('Insira um nome (exemplo: Bridgestone)');
    }

    saveEntity(formData);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.tireTreadManufacturer'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.tireTreadManufacturer.name')}</TypographyForms>
                      <TextFieldForms
                        value={formData['name']}
                        id={'tire-tread-manufacturer-name'}
                        data-cy={'name'}
                        name={'name'}
                        onChange={e => handleInputChange('name', e.target.value)}
                      />
                    </FormControlDefault>

                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default TireTreadManufacturerUpdate;